import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import App from './App.vue'
import VueMoment from 'vue-moment';
import { BootstrapVue } from 'bootstrap-vue';
import VueScrollTo from 'vue-scrollto';
// ============== Libraries ==============
import VueSweetalert2 from 'vue-sweetalert2'
// ============== CLIENT COMPONENTS ==============
import HomeScreen from './screens/public/HomeScreen'
import KakusanScreen from './screens/public/KakusanScreen'
import InvestigateScreen from './screens/public/InvestigateScreen'
import SafetyScreen from './screens/public/SafetyScreen'
import ManufacturingScreen from './screens/public/ManufacturingScreen'
import PatentsScreen from './screens/public/PatentsScreen'
import ProductsScreen from './screens/public/ProductsScreen'
import ProductDetailScreen from './screens/public/ProductDetailScreen'
// 2024/12/6 2024/12/6 新增針對越南所需 會員事業手冊－制度篇
import MembershipSystemScreen from './screens/public/MembershipSystemScreen'
import ContributionScreen from './screens/public/ContributionScreen'
import CompanyScreen from './screens/public/CompanyScreen'
import CompanyIntroScreen from './screens/public/CompanyIntroScreen'
import CompanyPhilosophyScreen from './screens/public/CompanyPhilosophyScreen'
import PublicNewsScreen from './screens/public/PublicNewsScreen'
import PublicNewsDetailScreen from './screens/public/PublicNewsDetailScreen'
import PublicActivityListScreen from './screens/public/PublicActivityListScreen'
import PublicActivityDetailScreen from './screens/public/PublicActivityDetailScreen'
import DownloadDocsScreen from './screens/public/DownloadDocsScreen'
import PrivacyScreen from './screens/public/PrivacyScreen'
import LoginScreen from './screens/LoginScreen'
// ============== MEMBERS COMPONENTS ==============
import NewsScreen from './screens/member/NewsScreen'
import ActivityListScreen from './screens/member/ActivityListScreen'
import ActivityDetailScreen from './screens/member/ActivityDetailScreen'
import AnnouncementListScreen from './screens/member/AnnouncementListScreen'
import MemberScreen from './screens/member/MemberScreen'
import HierarchyScreen from './screens/member/HierarchyScreen'
import HierarchyDetailScreen from './screens/member/HierarchyDetailScreen';
import HierachySubScreen from './screens/member/HierachySubScreen';
import BonusListScreen from './screens/member/BonusListScreen'
import RecordListScreen from './screens/member/RecordListScreen'
import AccountSettingsScreen from './screens/member/AccountSettingsScreen'
import WebsiteScreen from './screens/member/WebsiteScreen'
import OrderMainScreen from './screens/member/OrderMainScreen'
import PointCardScreen from './screens/member/PointCardScreen'
// 定期購買
import RegularOrderScreen from "./screens/member/RegularOrderScreen"
// 加購
import AdditionalOrderScreen from "./screens/member/AdditionalOrderScreen"
// 購物總覽
import OrderSummationScreen from "./screens/member/OrderSummationScreen"
// 付款
import OrderPaymentScreen from "./screens/member/OrderPaymentScreen"
// 付款完成
import OrderFinishedScreen from "./screens/member/OrderFinishedScreen"

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.prototype.$hostURL = "https://fordays-backend-official.herokuapp.com";

require("vue-pure-lightbox/dist/VuePureLightbox.css");
require("./assets/scss/bootstrap.scss");
require("./assets/scss/style.scss");
require("./assets/public/scss/public-style.scss");

Vue.use(VueAxios, axios)
Vue.use(VueRouter)
Vue.use(VueSweetalert2)
Vue.use(VueMoment)
Vue.use(BootstrapVue)
Vue.use(VueScrollTo)

Vue.config.productionTip = false

const requireLoginMeta = {
  meta: {
    requireLogin: true
  }
}

export const router = new VueRouter({
  // HTML5 History Mode
  mode: 'history',
  // Scroll to top position after routing
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes:
    [
      // 前端靜態頁面
      // 首頁
      {
        path: '/',
        component: HomeScreen
      },
      // 核酸是什麼
      { path: '/kakusan', component: KakusanScreen },
      // 學術研究
      { path: '/kakusan/investigate', component: InvestigateScreen },
      // Fordays品質
      { path: '/safety', component: SafetyScreen },
      // 製品的安全性
      { path: '/safety/manufacturing', component: ManufacturingScreen },
      // 專利權資訊
      { path: '/safety/patents', component: PatentsScreen },
      // 產品信息
      { path: '/products', component: ProductsScreen },
      // 產品詳情
      { path: '/products/:pid', component: ProductDetailScreen },
      // 2024/12/6 2024/12/6 新增針對越南所需 會員事業手冊－制度篇
      { path: '/membershipSystem', component: MembershipSystemScreen },
      // 企業社會責任
      { path: '/contribution', component: ContributionScreen },
      // Fordays公司資訊
      { path: '/company', component: CompanyScreen },
      // 企業宗旨、企業理念、事業方針
      { path: '/company/intro', component: CompanyIntroScreen },
      // 社長的話
      { path: '/company/philosophy', component: CompanyPhilosophyScreen },
      // 新聞
      { path: '/news', component: PublicNewsScreen },
      // 新聞詳情
      { path: '/news/:newsId', component: PublicNewsDetailScreen },
      // 活動列表
      { path: '/activity-list', component: PublicActivityListScreen },
      // 活動詳情
      { path: '/activity-list/:activityId', component: PublicActivityDetailScreen },
      // 下載文件
      { path: '/download-docs', component: DownloadDocsScreen },
      // 隱私權政策
      { path: '/privacy', component: PrivacyScreen },
      {
        path: '/',
        component: LoginScreen
      },
      {
        path: '/member/news',
        component: NewsScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/news/announcement-list',
        component: AnnouncementListScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/news/activity-list',
        component: ActivityListScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/news/activity-list/:activityId',
        component: ActivityDetailScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/member',
        component: MemberScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/hierarchy',
        component: HierarchyScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/hierarchy/detail',
        component: HierarchyDetailScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/hierarchy/sub',
        component: HierachySubScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/point-card',
        component: PointCardScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/record-list',
        component: RecordListScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/bonus-list',
        component: BonusListScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/account-settings',
        component: AccountSettingsScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/order-main',
        component: OrderMainScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/regular-order',
        component: RegularOrderScreen,
        ...requireLoginMeta
      },
      {
        path: '/member/additional-order',
        component: AdditionalOrderScreen,
        ...requireLoginMeta
      },
      {
        name: "OrderSummationScreen",
        path: '/member/order-summation',
        component: OrderSummationScreen,
        ...requireLoginMeta,
        props: true
      },
      {
        name: "OrderPaymentScreen",
        path: '/member/order-payment',
        component: OrderPaymentScreen,
        ...requireLoginMeta,
        props: true
      },
      {
        name: "OrderFinishedScreen",
        path: '/member/order-finished',
        component: OrderFinishedScreen,
        ...requireLoginMeta,
        props: true
      },
      {
        path: '/member/website',
        component: WebsiteScreen,
        ...requireLoginMeta
      }
    ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireLogin)) {
    const isLogin = store.state.auth.auth.isLogin;
    if (isLogin) {
      next();
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    next();
  }
})


new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
